import React, { useState, useEffect } from 'react'
import { supabase } from '../../supabase'
import Logo from '../common/Logo'

const NAV_CONFIG = {
  architecte: [
    {
      section: 'Principal',
      items: [
        { id: 'dashboard', label: 'Tableau de bord', icon: '🏠' },
        { id: 'chantiers', label: 'Mes chantiers', icon: '🏗️' },
        { id: 'taches', label: 'Taches', icon: '✅' },
        { id: 'messages', label: 'Messages', icon: '💬' },
      ]
    },
    {
      section: 'Gestion',
      items: [
        { id: 'documents', label: 'Documents', icon: '📄' },
        { id: 'photos', label: 'Photos', icon: '📷' },
        { id: 'intervenants', label: 'Intervenants', icon: '👥' },
        { id: 'notifications', label: 'Notifications', icon: '🔔' },
      ]
    }
  ],
  entreprise: [
    {
      section: 'Principal',
      items: [
        { id: 'dashboard', label: 'Tableau de bord', icon: '🏠' },
        { id: 'taches', label: 'Mes taches', icon: '✅' },
        { id: 'messages', label: 'Messages', icon: '💬' },
        { id: 'photos', label: 'Photos chantier', icon: '📷' },
      ]
    },
    {
      section: 'Informations',
      items: [
        { id: 'chantiers', label: 'Chantiers', icon: '🏗️' },
        { id: 'documents', label: 'Documents', icon: '📄' },
        { id: 'notifications', label: 'Notifications', icon: '🔔' },
      ]
    }
  ],
  client: [
    {
      section: 'Mon chantier',
      items: [
        { id: 'dashboard', label: "Vue d'ensemble", icon: '🏠' },
        { id: 'avancement', label: 'Avancement', icon: '📊' },
        { id: 'photos', label: 'Photos', icon: '📷' },
        { id: 'documents', label: 'Documents', icon: '📄' },
      ]
    }
  ]
}

const ROLE_LABELS = {
  architecte: 'Architecte / MOE',
  entreprise: 'Entreprise',
  client: 'Client'
}

function ModalProfil({ user, profile, onClose }) {
  const [form, setForm] = React.useState({
    prenom: profile?.prenom || '',
    nom: profile?.nom || '',
  })
  const [pwd, setPwd] = React.useState('')
  const [saving, setSaving] = React.useState(false)
  const [msg, setMsg] = React.useState('')

  const saveProfile = async (e) => {
    e.preventDefault()
    setSaving(true)
    setMsg('')
    const { error } = await supabase.from('profiles').update({ prenom: form.prenom, nom: form.nom }).eq('id', user.id)
    if (pwd.trim().length >= 6) {
      await supabase.auth.updateUser({ password: pwd.trim() })
    }
    setSaving(false)
    setMsg(error ? 'Erreur : ' + error.message : 'Profil mis a jour !')
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 500, padding: 20 }}>
      <div style={{ background: 'white', borderRadius: 14, padding: '28px 32px', maxWidth: 400, width: '100%' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <div style={{ fontWeight: 700, fontSize: 16 }}>Mon profil</div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', color: '#a0aec0' }}>×</button>
        </div>
        <form onSubmit={saveProfile}>
          <div style={{ display: 'flex', gap: 12, marginBottom: 14 }}>
            <div style={{ flex: 1 }}>
              <label style={{ fontSize: 12, color: '#718096', display: 'block', marginBottom: 4 }}>Prenom</label>
              <input value={form.prenom} onChange={e => setForm({ ...form, prenom: e.target.value })}
                style={{ width: '100%', padding: '8px 12px', border: '1.5px solid #e2e8f0', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }} />
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ fontSize: 12, color: '#718096', display: 'block', marginBottom: 4 }}>Nom</label>
              <input value={form.nom} onChange={e => setForm({ ...form, nom: e.target.value })}
                style={{ width: '100%', padding: '8px 12px', border: '1.5px solid #e2e8f0', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }} />
            </div>
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={{ fontSize: 12, color: '#718096', display: 'block', marginBottom: 4 }}>Email</label>
            <input value={user?.email || ''} disabled style={{ width: '100%', padding: '8px 12px', border: '1.5px solid #e2e8f0', borderRadius: 8, fontSize: 14, background: '#f5f6fa', color: '#a0aec0', boxSizing: 'border-box' }} />
          </div>
          <div style={{ marginBottom: 18 }}>
            <label style={{ fontSize: 12, color: '#718096', display: 'block', marginBottom: 4 }}>Nouveau mot de passe <span style={{ opacity: 0.6 }}>(laisser vide pour ne pas changer)</span></label>
            <input type="password" value={pwd} onChange={e => setPwd(e.target.value)} placeholder="6 caracteres minimum"
              style={{ width: '100%', padding: '8px 12px', border: '1.5px solid #e2e8f0', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }} />
          </div>
          {msg && <div style={{ fontSize: 13, color: msg.includes('Erreur') ? '#e53e3e' : '#1D9E75', marginBottom: 12, fontWeight: 500 }}>{msg}</div>}
          <div style={{ display: 'flex', gap: 10 }}>
            <button type="button" onClick={onClose} style={{ flex: 1, padding: '10px 0', background: '#f5f6fa', border: '1.5px solid #e2e8f0', borderRadius: 8, cursor: 'pointer', fontWeight: 500 }}>Annuler</button>
            <button type="submit" disabled={saving} style={{ flex: 1, padding: '10px 0', background: '#1D9E75', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>{saving ? 'Sauvegarde...' : 'Sauvegarder'}</button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default function Sidebar({ role, activePage, onNavigate, user, onLogout, profile, isOpen }) {
  const navSections = NAV_CONFIG[role] || NAV_CONFIG.client
  const [notifCount, setNotifCount] = useState(0)
  const [msgCount, setMsgCount] = useState(0)
  const [showProfil, setShowProfil] = useState(false)

  const loadMsgCount = React.useCallback(async () => {
    if (!user || !user.id) return
    const { count } = await supabase
      .from('messages_chantier')
      .select('id', { count: 'exact', head: true })
      .eq('lu', false)
      .neq('auteur_id', user.id)
    setMsgCount(count || 0)
  }, [user])

  const initials = profile?.prenom && profile?.nom
    ? (profile.prenom[0] + profile.nom[0]).toUpperCase()
    : user?.email?.[0]?.toUpperCase() || '?'

  const displayName = profile?.prenom && profile?.nom
    ? profile.prenom + ' ' + profile.nom
    : user?.email || 'Utilisateur'

  useEffect(() => { loadMsgCount() }, [loadMsgCount])

  useEffect(() => {
    if (!user || !user.id) return
    const channel = supabase.channel('sidebar-msgs-' + user.id)
      .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'messages_chantier' },
        () => { loadMsgCount() })
      .subscribe()
    return () => { supabase.removeChannel(channel) }
  }, [user, loadMsgCount])

  useEffect(() => {
    if (activePage === 'messages' && user && user.id) {
      supabase.from('messages_chantier')
        .update({ lu: true })
        .eq('lu', false)
        .neq('auteur_id', user.id)
        .then(() => setMsgCount(0))
    }
  }, [activePage, user])

  useEffect(() => {
    if (!user || !user.id) return
    supabase.from('notifications')
      .select('id', { count: 'exact', head: true })
      .eq('user_id', user.id).eq('lu', false)
      .then(({ count }) => setNotifCount(count || 0))

    const channel = supabase.channel('sidebar-notifs-' + user.id)
      .on('postgres_changes', {
        event: 'INSERT',
        schema: 'public',
        table: 'notifications',
        filter: 'user_id=eq.' + user.id,
      }, () => {
        setNotifCount(prev => prev + 1)
      })
      .on('postgres_changes', {
        event: 'UPDATE',
        schema: 'public',
        table: 'notifications',
        filter: 'user_id=eq.' + user.id,
      }, () => {
        supabase.from('notifications')
          .select('id', { count: 'exact', head: true })
          .eq('user_id', user.id).eq('lu', false)
          .then(({ count }) => setNotifCount(count || 0))
      })
      .subscribe()

    return () => { supabase.removeChannel(channel) }
  }, [user])

  return (
    <aside className={'sidebar' + (isOpen ? ' open' : '')}>
      <div className="sidebar-header">
        <Logo size="sm" withText={true} textColor="white" />
        <div className="sidebar-role-badge" style={{ marginLeft: 'auto' }}>{ROLE_LABELS[role] || role}</div>
      </div>

      <nav className="sidebar-nav">
        {navSections.map(section => (
          <div key={section.section}>
            <div className="nav-section-label">{section.section}</div>
            {section.items.map(item => (
              <button
                key={item.id}
                id={item.id === 'chantiers' ? 'step-nav-chantiers' : item.id === 'taches' ? 'step-nav-taches' : undefined}
                className={'nav-item ' + (activePage === item.id ? 'active' : '')}
                onClick={() => onNavigate(item.id)}
                style={{ display: 'flex', alignItems: 'center', width: '100%' }}
              >
                <span className="nav-icon">{item.icon}</span>
                <span style={{ flex: 1, textAlign: 'left' }}>{item.label}</span>
                {item.id === 'messages' && msgCount > 0 && (
                  <span style={{
                    background: '#e53e3e', color: 'white', borderRadius: 10,
                    padding: '1px 7px', fontSize: 11, fontWeight: 700,
                    lineHeight: '18px', minWidth: 18, textAlign: 'center',
                  }}>
                    {msgCount > 99 ? '99+' : msgCount}
                  </span>
                )}
                {item.id === 'notifications' && notifCount > 0 && (
                  <span style={{
                    background: '#e53e3e', color: 'white', borderRadius: 10,
                    padding: '1px 7px', fontSize: 11, fontWeight: 700,
                    lineHeight: '18px', minWidth: 18, textAlign: 'center',
                  }}>
                    {notifCount > 99 ? '99+' : notifCount}
                  </span>
                )}
              </button>
            ))}
          </div>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div className="user-info" onClick={() => setShowProfil(true)} style={{ cursor: 'pointer' }} title="Modifier mon profil">
          <div className="user-avatar">{initials}</div>
          <div className="user-details">
            <div className="user-name">{displayName}</div>
            <div className="user-email" style={{ fontSize: 10, opacity: 0.7 }}>✏️ Modifier le profil</div>
          </div>
        </div>
        <button className="btn-logout" onClick={onLogout}>
          Se deconnecter
        </button>
      </div>
      {showProfil && user && (
        <ModalProfil user={user} profile={profile} onClose={() => setShowProfil(false)} />
      )}
    </aside>
  )
}
